import { NetworkManager } from "@src/infrastructure/services/network/Network.manager";
import type { IHttpClientModel } from "@ir/core/http";
import { AuthUserTokenService } from "@src/infrastructure/auth/AuthUserTokenService";

export class PrivateHttp extends NetworkManager {
  constructor(_networkConfig?: Omit<IHttpClientModel, "baseURL">) {
    super(_networkConfig);
    this.handlePrivateRequest();
  }

  protected handlePrivateRequest() {
    this.httpService.interceptors.request.use(
      async config => {
        const userAccessToken = await this.getUserAccessToken();
        const adminAccessToken = await this.getAdminAccessToken();
        const adminRefreshToken = await this.getAdminRefreshToken();

        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${userAccessToken}`,
          ["X-Admin-Authorization"]: `Bearer ${adminAccessToken}`,
          ["X-Admin-Refresh-Token"]: `Bearer ${adminRefreshToken}`,
        };
        return config;
      },
      error => {
        return Promise.reject(error instanceof Error ? error : new Error(String(error)));
      }
    );
  }

  protected async getUserAccessToken() {
    const userAccessToken = await new AuthUserTokenService().getAuthAccessToken();
    return userAccessToken;
  }

  protected async getAdminAccessToken() {
    const adminAccessToken = await new AuthUserTokenService().getAdminAccessToken();
    return adminAccessToken;
  }

  protected async getAdminRefreshToken() {
    const adminRefreshToken = await new AuthUserTokenService().getAdminRefreshToken();
    return adminRefreshToken;
  }
}
